<template>
  <div class="bg-gray-900">

    <div class="relative isolate overflow-hidden pt-14 bg-hero">
      <!-- <img :src="brandService.getHeroImage()" alt=""
        style="top: 50%; left: 50%; transform: translate(-50%, -50%);" class="absolute inset-0 -z-10 object-cover object-center w-full" /> -->
      <div class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80" aria-hidden="true">
        <div class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
      </div>
      <div class="max-w-7xl px-6 lg:px-12">
        <div class="max-w-2xl py-32 sm:py-48 lg:py-52">
          <div class="hidden sm:mb-8 sm:flex sm:justify-start">
            <!-- <div class="relative rounded-full px-3 py-1 text-sm/6 text-gray-400 ring-1 ring-white/10 hover:ring-white/20">
              Announcing our next round of funding. <a href="#" class="font-semibold text-white"><span class="absolute inset-0" aria-hidden="true" />Read more <span aria-hidden="true">&rarr;</span></a>
            </div> -->
          </div>
          <div class="text-left relative pt-36 md:pt-0">
            <h1 class="text-balance md:text-5xl font-benzin tracking-normal text-white text-3xl md:pt-0 pt-6">HERE. NOW. <span class="text-black font-benzin-black">ON.</span></h1>
            <p class="mt-8 text-pretty md:text-lg font-poppins text-white text-16 leading-5 md:leading-normal max-w-sm">Welcome to Nexee. Now you can thrive and live an easier life, thanks to our high-speed, reliable broadband. Discover your options today.</p>

            <AddressSearch :autocompleted-addresses="autocompletedAddresses" :address="address" @onAutocompletedAddressClicked="(address) => emit('onAutocompletedAddressClicked', address)" @onCheckAddressClicked="(address, done) => emit('onCheckAddressClicked', address, done)" @onAddressSearchInputted="(address) => emit('onAddressSearchInputted', address)" />
          </div>
        </div>
      </div>
      <div class="hidden lg:block absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]" aria-hidden="true">
        <div class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]" style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" />
      </div>
    </div>
  </div>
</template>

<script lang='ts' setup>
import AddressSearch from './AddressSearch.vue';
import Container from './Container.vue';
import { defineEmits, defineProps, ref } from 'vue';
import { CheckIcon, Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
import { Dialog, DialogPanel } from '@headlessui/vue';
import { Address } from '@/adapters/autocompleteAddressAdapterInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '../../services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const emit = defineEmits<{(e: 'onCheckAddressClicked', address: string, done: () => void): void, (e: 'onAddressSearchInputted', address: string): void, (e: 'onAutocompletedAddressClicked', address: Address): void}>();

defineProps<{
  autocompletedAddresses: Array<Address>,
  address: string
}>();
</script>

<style scoped>
.bg-hero {
  background-color: #E4E4E4;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/bg-hero-nex.png");
  background-position: center;
  background-size: cover;
  height: 100vh;
}

@media only screen and (max-width: 768px) {
  .bg-hero {
    background: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/mobile-bg-home.png") no-repeat , url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/mobile-bg-home-1.png") no-repeat;
    background-position-y: 150px, top ;
    background-size: contain, contain;
    height: 100%;
  }
}
</style>
